$(document).ready(function(){
	document.body.style.setProperty(
		"--scrollbar-width",
		`${window.innerWidth - document.body.clientWidth}px`
	);
});
